import React, { useContext, useMemo } from 'react';
import filterBarManual from '../../../../modules/filterBarManual';
import Translate from '../../../Translate/Translate';
import PreferencesContext from '~/containers/Preferences/PreferencesContext';

const OperatorsHelperText = () => {
    const preferencesContext = useContext(PreferencesContext);

    const manual = useMemo(() => {
        return filterBarManual
            .filter(subsection => {
                const hiddenItems =
                    preferencesContext.operatorHelpTextHiddenItems || [];
                return !hiddenItems.includes(subsection.title);
            })
            .map((subsection, i) => {
                const section = subsection.subsection.map((section, j) => {
                    return (
                        <div key={'s' + j}>
                            {section.subtitle ? (
                                <h6
                                    className="my-2"
                                    style={{ fontSize: '12px', color: 'white' }}
                                >
                                    <Translate message={section.subtitle} />
                                </h6>
                            ) : null}
                            {section.examples ? (
                                <div className="mb-2">
                                    {section.examples.map((example, k) => {
                                        return (
                                            <div key={'ex' + k}>
                                                <code className="command ps-1 pe-1 me-2">
                                                    {example}
                                                </code>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : null}
                            {section.description ? (
                                <p className="mt-1">
                                    <Translate message={section.description} />
                                </p>
                            ) : null}
                        </div>
                    );
                });
                return (
                    <div key={'ss' + i} className="pb-3">
                        <h6>
                            <Translate message={subsection.title} />
                        </h6>
                        {section}
                    </div>
                );
            });
    }, [preferencesContext.operatorHelpTextHiddenItems]);

    return <div>{manual}</div>;
};

export default OperatorsHelperText;
